
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormCol"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormCol"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"as"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormRowLevel1"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldsetLevel1"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"props"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormColProps"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"className"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewVariant"},"arguments":[],"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("./FormRowLevel1.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./FormFieldsetLevel1.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./FormField.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./FormColProps.fragment.graphql").definitions));


    module.exports = doc
  
